import UtilityFunction from '../Util/Util';
import api from './API';

const basePath = 'cart';
const pathList = {
    cart: `/`,
    cartProducts: `/items`,
    cartProductItem: `/:param`,
    cartClear: `/clear`
};

for(let key in pathList) {
    pathList[key] = basePath + pathList[key];
}

pathList.newDesignCount = `/customer-design/count`;

const call = {
    getCartProducts: async(productIds, sizeIds, addons, straws, withSizeOptions = 0) => {
        try {
            const apiPath = pathList.cartProducts;
            const cartProducts = await api.getCall(apiPath, null, {
                id: productIds,
                size_id: sizeIds,
                addons: addons,
                straws,
                with_size_options: withSizeOptions
            });
    
            return cartProducts;
        } catch(e) {
            console.log(e.toString());
        }
    },
    saveCartProducts: async(argToken, argProducts) => {
        try {
            const apiPath = pathList.cartProducts;
            const response = await api.postCall(apiPath, null, {
                products: argProducts
            });

            return response;
        } catch(e) {
            console.log(e.toString());
        }
    },
    removeCartProduct: async(argToken, argProductId) => {
        try {
            const apiPath = pathList.cartProductItem;
            const response = await api.deleteCall(apiPath, argProductId, {}, argToken);

            return response;
        } catch(e) {
            console.log(e.toString());
        }
    },
    loadUserCart: async(argToken) => {
        try {
            const apiPath = pathList.cart;
            const response = await api.getCall(apiPath, null, {}, argToken);

            return response;
        } catch(e) {
            console.log(e.toString());
        }
    },
    addToCart: async (argToken, argProduct) => {
        try {
            const apiPath = pathList.cart;
            const response = await api.postCall(apiPath, null, {
                product: argProduct
            }, argToken);

            return response;
        } catch(e) {
            console.log(e.toString());
        }
    },
    clearCart: async (argToken) => {
        try {
            const apiPath = pathList.cartClear;
            const response = await api.deleteCall(apiPath, null, {}, argToken);

            return response;
        } catch(e) {
            console.log(e.toString());
        }
    },
    newDesignCount: async (customerId, customerName, whatsappNo, productIds, sizeIds, designAttachment) => {
        try {
            const apiPath = pathList.newDesignCount;
            const headers = {
                'Content-Type': 'multipart/form-data',
            };
            const response = await api.postCall(apiPath, null, {
                customerId,
                customerName,
                whatsappNo,
                productId: JSON.stringify(productIds),
                sizeId: JSON.stringify(sizeIds),
                design_attachment: designAttachment
            }, headers);

            return response;
        } catch(e) {
            console.log(e.toString());
        }
    }
}

const controller = {
    getAll: () => {
        let storage = localStorage.getItem('shoppingCart');
        
        if(storage === null || storage === '' || storage === '{}') {
            storage = {};
        } else {
            storage = JSON.parse(storage);
        }


        return storage;
    },
    get: (ownerCode = 'guest') => {
        let storage = controller.getAll();

        if(!storage.hasOwnProperty(ownerCode)) {
            storage[ownerCode] = {};
        }

        return storage[ownerCode];
    },
    save: (ownerCode = 'guest', cartItem, transactionNotes = "") => {
        const existingShoppingCart = controller.getAll();
        const { 
            productId, 
            sizeId, 
            // quantity 
        } = cartItem;

        try {
            // const variantCode = UtilityFunction.base64encode(`${ productId }-${ sizeId }`);
            const variantCode = controller.cartItemCode(productId, sizeId);

            if(!existingShoppingCart.hasOwnProperty(ownerCode)) existingShoppingCart[ownerCode] = {};
            
            if(!existingShoppingCart[ownerCode].hasOwnProperty(variantCode)) existingShoppingCart[ownerCode][variantCode] = {};
            
            existingShoppingCart[ownerCode][variantCode] = cartItem;        
            existingShoppingCart[ownerCode].transactionNotes = transactionNotes;

            localStorage.setItem('shoppingCart', JSON.stringify(existingShoppingCart));

            return true;
        } catch(e) {
            console.error(e);
            return false;
        }
    },
    delete: (ownerCode = 'guest', variantCode) => {
        const existingShoppingCart = controller.getAll();
        let deleteCustomDesign = false;

        try {
            delete existingShoppingCart[ownerCode][variantCode];
            if( Object.keys(existingShoppingCart[ownerCode]).length  === 1 && existingShoppingCart[ownerCode].hasOwnProperty('transactionNotes') ) {
                delete existingShoppingCart[ownerCode].transactionNotes;
                deleteCustomDesign = true;
            }

            localStorage.setItem('shoppingCart', JSON.stringify(existingShoppingCart));
    
            return deleteCustomDesign;
        } catch(e) {
            console.error(e);
            return deleteCustomDesign;
        }
    },
    clear: (ownerCode) => {
        const storage = controller.getAll();
        const lastOrderHistory = storage[ownerCode];
        storage[ownerCode] = {};
        
        localStorage.setItem('shoppingCart', JSON.stringify(storage));
        localStorage.setItem('lastOrderHistory', JSON.stringify(lastOrderHistory));
    },
    repeatOrder: (ownerCode) => {
        const storage = controller.getAll();
        const lastOrderHistory = shoppingCartAPI.controller.checkOrderHistory();
        storage[ownerCode] = lastOrderHistory;

        localStorage.setItem('shoppingCart', JSON.stringify(storage));
    },
    checkOrderHistory: () => {
        let lastOrderHistory = localStorage.getItem('lastOrderHistory');

        if(lastOrderHistory === null || lastOrderHistory === '' || lastOrderHistory === '{}' || lastOrderHistory === undefined) {
            lastOrderHistory = {};
        } else {
            lastOrderHistory = JSON.parse(lastOrderHistory);
        }

        return lastOrderHistory;
    },
    clearOrderHistory: () => {
        localStorage.setItem('lastOrderHistory', "{}");
    },
    clearAll: () => {
        localStorage.setItem('lastOrderHistory', '{}');
        localStorage.setItem('shoppingCart', '{}');
        localStorage.setItem('designAttachment', '');
    },
    cartItemCode: (productId, sizeId) => {
        return UtilityFunction.base64encode(`${ productId }-${ sizeId }`);
    }
}

const shoppingCartAPI = {
    call,
    controller
};

export default shoppingCartAPI;